import { createSlice, current } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import memberApi from '~workspace/services/member'
import workspaceApi from '~workspace/services/workspace'

export const workspaceInitialState = {
  error: '',
  workspace: {},
  isWorkspaceOwner: false,
  isWorkspaceMember: false,
  loading: false
}

export const workspaceSlice = createSlice({
  name: 'workspace',
  initialState: workspaceInitialState,
  reducers: {
    setIsWorkspaceOwner: (state, action) => {
      state.isWorkspaceOwner = action.payload
    },
    setIsWorkspaceMember: (state, action) => {
      state.isWorkspaceMember = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      memberApi.endpoints.deleteWorkspaceMember.matchFulfilled,
      (state, action) => {
        const {
          deleteWorkspaceMember: { id: memberId }
        } = action.payload

        const members = current(state.workspace.memberCollection.items)
        const newMembers = members.filter((member) => member.id !== memberId)

        state.workspace.memberCollection.items = newMembers
        state.workspace.memberCollection.total = newMembers.length
      }
    )

    builder.addMatcher(
      workspaceApi.endpoints.updateWorkspaceById.matchFulfilled,
      (state, action) => {
        state.workspace = { ...state.workspace, ...action.payload }
      }
    )
  }
})

export const {
  setWorkspaceLoading,
  setIsWorkspaceOwner,
  setIsWorkspaceMember
} = workspaceSlice.actions

export const useWorkspace = () =>
  useSelector((state) => state.workspace.workspace)

export const useIsWorkspaceOwner = () =>
  useSelector((state) => state.workspace.isWorkspaceOwner)

export const useIsWorkspaceMember = () =>
  useSelector((state) => state.workspace.isWorkspaceMember)

export const useWorkspaceLoading = () =>
  useSelector((state) => state.workspace.loading)

export const useWorkspaceError = () =>
  useSelector((state) => state.workspace.error)

export default workspaceSlice.reducer
